import SystemBannerNotifications from "@sourcewhale/shared/svelte-design-system/components/atoms/SystemBanner/SystemBannerNotifications.svelte";
import { mount } from "svelte";

export const bindSystemBannerNotifications = (parentId = "content-wrapper") => {
  const parent = document.getElementById(parentId) || document.body;

  if (document.getElementById("system-banner-notifications")) {
    console.warn("System Banner Notifications already mounted");
    return;
  }

  const target = document.createElement("div");
  target.id = "system-banner-notifications";
  parent.prepend(target);

  mount(SystemBannerNotifications, { target });
};
